<template>
  <b-card
      no-body
      class="border-primary"
  >
    <b-card-header class="d-flex justify-content-between align-items-center pt-75 pb-25">
      <b-skeleton animation="wave" class="w-100" v-if="loading"/>
      <div v-else class="d-flex justify-content-between w-100">
        <h5 class="mb-0 font-small-3">
          {{namePlan}}
        </h5>
        <b-badge variant="light-primary font-small-1">
          {{registerANS}}
        </b-badge>
      </div>
    </b-card-header>

    <b-card-body>
      <ul class="list-unstyled my-1">
        <li>
          <b-skeleton animation="wave" v-if="loading"/>
          <small v-else class="w-100 tex-">Vigência: <b>{{effectiveDate}}</b></small>
        </li>
        <li>
          <b-skeleton animation="wave" v-if="loading"/>
          <small v-else class="w-100">Qtde vidas: <b>{{numberLifes}}</b></small>
        </li>
        <li class="my-25">
          <b-skeleton animation="wave" v-if="loading"/>
          <small v-else class="w-100">Coparticipativo: <b>{{flgCopart === 'S' ? 'Sim' : 'Não'}}</b></small>
        </li>
        <li>
          <b-skeleton animation="wave" v-if="loading"/>
          <small v-else class="w-100">Acomodação: <b>{{acomodation}}</b></small>
        </li>
      </ul>
      <b-button
          variant="dark"
          block
          @click="redirectToPagePan"
      >
        Abrir informações do contrato
      </b-button>
    </b-card-body>
  </b-card>
</template>

<script>
import moment from 'moment';
import ContractService from "@/services/ContractService";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  name: "PlanCardInfo",
  mounted() {
    this.loading = true;
    ContractService.getResume().then(resp => {
      this.effectiveDate = moment(resp.data.data_vigencia).format('DD/MM/YYYY');
      this.namePlan = resp.data.nome_plano;
      this.registerANS = resp.data.registro_ans;
      this.flgCopart = resp.data.copart;
      this.numberLifes = resp.data.qtde_vidas;
      this.acomodation = resp.data.acomodacao;
      this.loading = false;
    }).catch(err => {
      this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              icon: 'BellIcon',
              text: 'Ocorreu um erro ao buscar os dados do contrato.',
              variant: 'danger',
            },
          },
          {
            position: 'top-center'
          })
      this.loading = false;
    })
  },
  data(){
    return {
      effectiveDate: null,
      namePlan: null,
      registerANS: null,
      flgCopart: null,
      numberLifes: null,
      acomodation: null,
      loading: false,
    }
  },
  methods:{
    redirectToPagePan(){
      this.$router.push('/contract-resume');
    }
  }
}
</script>

<style scoped>

</style>